export const sortableItemStyle = {
  userSelect: 'none' as const,
};

export const draggingItemStyle = {
  opacity: 0.5,
  userSelect: 'none' as const,
};
